import constants from '#packages/constants';
import type {
  SuperAppExternalTab,
  SuperAppTab,
  SuperAppsTabsOverrides,
} from '../types';

export const formatTab = (tab: SuperAppExternalTab): SuperAppTab => ({
  name: tab.name || constants.SUPER_APPS.MENU_PANEL_TAB_NAMES.MANAGE,
  isDynamicHeight: tab.isDynamicHeight,
  title: tab.title,
  helpId: tab.helpId,
  content: tab.template,
  className: tab.isPremiumSkin ? 'upgrade' : '',
  showDotIndicator: tab.showDotIndicator,
  tabWrapper: tab.tabWrapper,
});

export const applyExternalTabs = (
  externalTabs: SuperAppExternalTab[],
  target: SuperAppTab[],
  overrides: SuperAppsTabsOverrides = {},
) => {
  externalTabs
    .sort((tab) => tab.index)
    .forEach((tab) => {
      const formattedTab = formatTab(tab);
      const tabOverrides = overrides[formattedTab.name] || {};
      const tabInfo = {
        ...formattedTab,
        ...tabOverrides,
      };
      if (tabInfo.isHidden) {
        return;
      }
      target.splice(tab.index, 0, tabInfo);
    });
};
